import _ from 'lodash'

import defaultState from '@/store/modules/improvementIdea/state'
import mutationsHelpers from '@/store/modules/rev/mutationsHelpers.js'
import types from '../types'
import setRev from './setRev'

export default {
  [types.SET_REV]: setRev,

  [types.SET_CHALLENGES](state, challenges) {
    state.challenges = challenges
  },

  updateProblem(state, problem) {
    state.rev = {
      ...state.rev,
      problemAnalysis: {
        ...(state?.rev?.problemAnalysis ?? {}),
        problem,
      },
    }
  },

  updateProblemMedia(state, problemMedia) {
    state.rev = {
      ...state.rev,
      problemAnalysis: {
        ...(state?.rev?.problemAnalysis ?? {}),
        problemMedia,
      },
    }
  },

  updateContainmentPlan(state, containment) {
    state.rev = {
      ...state.rev,
      problemAnalysis: {
        ...(state?.rev?.problemAnalysis ?? {}),
        containment,
      },
    }
  },

  updateCountermeasuresMedia(state, countermeasuresMedia) {
    state.rev = {
      ...state.rev,
      problemAnalysis: {
        ...(state?.rev?.problemAnalysis ?? {}),
        countermeasuresMedia,
      },
    }
  },

  updateSpecificGoals(state, goals) {
    state.rev = {
      ...state.rev,
      problemAnalysis: {
        ...(state?.rev?.problemAnalysis ?? {}),
        goals,
      },
    }
  },

  updateBusinessRequirements(state, businessRequirements) {
    state.rev = {
      ...state.rev,
      problemAnalysis: {
        ...(state?.rev?.problemAnalysis ?? {}),
        businessRequirements,
      },
    }
  },

  updateProblemBreakdown(state, problemBreakdown) {
    state.rev = {
      ...state.rev,
      problemBreakdown: {
        ...state?.rev?.problemBreakdown,
        ...problemBreakdown,
      },
    }
  },

  updateMeasureDescription(state, measureDescription) {
    state.rev = {
      ...state.rev,
      problemAnalysis: {
        ...(state?.rev?.problemAnalysis ?? {}),
        measureDescription,
      },
    }
  },

  updateMeasureMedia(state, measureMedia) {
    state.rev = {
      ...state.rev,
      problemAnalysis: {
        ...(state?.rev?.problemAnalysis ?? {}),
        measureMedia,
      },
    }
  },

  updateMeasureAttachments(state, measureAttachments) {
    state.rev = {
      ...state.rev,
      problemAnalysis: {
        ...(state?.rev?.problemAnalysis ?? {}),
        measureAttachments,
      },
    }
  },

  updateRootCauseMedia(state, rootCauseMedia) {
    state.rev = {
      ...state.rev,
      problemAnalysis: {
        ...(state?.rev?.problemAnalysis ?? {}),
        rootCauseMedia,
      },
    }
  },

  updateRootCauses(state, rootCauses) {
    state.rev = {
      ...state.rev,
      rootCauses,
    }
  },

  updateProcessMapMedia(state, processMapMedia) {
    state.rev = {
      ...state.rev,
      processMapMedia,
    }
  },

  [types.SET_AVAILABLE_OWNERS](state, { results }) {
    state.availableOwners = [...results.map(mutationsHelpers.formatUser)]
  },

  [types.SET_AVAILABLE_COACHES](state, { results }) {
    state.availableCoaches = [...results.map(mutationsHelpers.formatCoach)]
  },

  [types.SET_AVAILABLE_COLLABORATORS](state, { results }) {
    state.availableCollaborators = [...results.map(mutationsHelpers.formatUser)]
  },

  resetRev(state, rev) {
    state.rev = rev || _.cloneDeep(defaultState.rev)
  },

  updateName(state, name) {
    state.rev.name = name
  },

  setCoach(state, coach) {
    state.rev.team.coach = coach
  },
  setOwner(state, owner) {
    state.rev.team.owner = owner
  },
  setCollaborators(state, collaborators) {
    state.rev.team.collaborators = collaborators
  },

  updateImpactMetrics(state, metrics) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        impacts: metrics,
      },
    }
  },

  updateInvestments(state, investments) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        investments: investments,
      },
    }
  },

  updateStartDate(state, date) {
    state.rev.impactStartsAt = date
  },

  updateEndDate(state, date) {
    state.rev.impactEndsAt = date
  },

  updateCostReduction(state, costReduction) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        costReduction: {
          capturedValue: costReduction,
        },
      },
    }
  },

  updateInvestment(state, investment) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        investment: {
          capturedValue: investment,
        },
      },
    }
  },

  updateEstimationExplanation(state, estimationExplanation) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        estimationExplanation,
      },
    }
  },

  updateRevenue(state, revenue) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        revenue: {
          capturedValue: revenue,
        },
      },
    }
  },

  updateTimeInvested(state, timeInvested) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        timeTracking: {
          ...state.rev.reviewPhase.timeTracking,
          timeInvested,
        },
      },
    }
  },

  updateNotes(state, notes) {
    state.rev.notes = notes
  },

  updateTimeReductionByMonth(state, timeReductionByMonth) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        timeTracking: {
          ...state.rev.reviewPhase.timeTracking,
          timeReductionByMonth,
        },
      },
    }
  },

  updateSolutionDescription(state, solutionDescription) {
    state.rev = {
      ...state.rev,
      solutionDescription,
    }
  },

  updateSolutionMedia(state, solutionMedia) {
    state.rev = {
      ...state.rev,
      solutionMedia,
    }
  },

  updateCategories(state, categories) {
    state.rev = {
      ...state.rev,
      categories,
    }
  },

  updateLocation(state, location) {
    state.rev = {
      ...state.rev,
      location: {
        organization: location.organization,
        site: location.site,
        tags: location.tags || [],
      },
    }
  },

  updatePriority(state, priority) {
    state.rev.priority = priority
  },

  updateDueDate(state, date) {
    state.rev.dueDate = date
  },
}
